import { useQuery, UseQueryResult } from 'react-query';
import { Api } from 'lavva.exalushome';
import { IUpdatesService } from 'lavva.exalushome/build/js/Services/Updates/IUpdatesService';
import { UpdatesService } from 'lavva.exalushome/build/js/Services/Updates/UpdatesService';
import { useBackdropContext } from '../../../context/backdrop';
import { useExalusContext } from '../context';

export const useExalusUpdatesSettingsAvailable = (): UseQueryResult<boolean> => {
  const { connected, selectedExalusCredentials, synchronized } = useExalusContext();
  const { turnOnBackdrop, turnOffBackdrop } = useBackdropContext();

  return useQuery<boolean>(
    ['exalus-updates-settings-available', selectedExalusCredentials?.id, synchronized],
    async () => {
      turnOnBackdrop();
      const updateService = Api.Get<IUpdatesService>(UpdatesService.ServiceName);
      const result = await updateService.IsBranchAndAutomaticUpdatesSettingSupportedAsync();

      turnOffBackdrop();
      return result;
    },
    {
      enabled: connected && !!selectedExalusCredentials?.id && synchronized,
      retry: false,
      onError: () => turnOffBackdrop(),
    },
  );
};
